import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { css } from 'styled-components';
import { responsive } from '@design-system/theme';
import { BaseInput } from './BaseInput';
export const TextAreaInput = forwardRef((_a, ref) => {
    var { labelPosition = 'top', minHeight = 60, variant = 'normal', width = '100%' } = _a, props = __rest(_a, ["labelPosition", "minHeight", "variant", "width"]);
    return (_jsx(BaseInput, Object.assign({}, props, { inputProps: {
            as: 'textarea',
            css: css `
          ${minHeight && `min-height: ${minHeight}px;`}

          overflow-y: auto;
          ${responsive('l') `
            overflow-y: none;
          `}
        `,
            height: 'auto',
        }, labelPosition: labelPosition, ref: ref, variant: variant, width: width })));
});
//# sourceMappingURL=TextAreaInput.js.map